import * as Create  from './create';
import * as Update from './update';
import * as Delete  from './delete';
import * as Get     from './get';
import * as Artwork from './artwork';

export const actiontypes = {
  ...Create.actiontypes,
  ...Update.actiontypes,
  ...Delete.actiontypes,
  ...Get.actiontypes,
  ...Artwork.actiontypes
}
export const actions = {
  ...Create.actions,
  ...Update.actions,
  ...Delete.actions,
  ...Get.actions,
  ...Artwork.actions
}



// WEBPACK FOOTER //
// ./src/actions/tracks/index.js